<template>
    <div class="main">
        <c-panel>

            <el-form @submit.native.prevent="onSubmitParametro" style="min-height: 130px;" v-loading="editParametro && !dados.id" :model="dados" ref="dados" label-position="top">
                <div v-if="!editParametro || dados.id">

                    <div class="style-form">
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24">                
                                <label>Período Letivo Corrente</label>
                                <div>
                                    <div class="style-input">{{ dados.periodo_letivo_base_nome }}</div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                                
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Sistema de Pré-matrícula Online" prop="status_pre_matricula" :rules="[$requiredChange]" key="status_pre_matricula">
                                <el-select v-model="dados.status_pre_matricula">
                                    <el-option :key="true" label="ATIVO" :value="true"></el-option>
                                    <el-option :key="false" label="INATIVO" :value="false"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>  

                    <el-row :gutter="10">
                        <el-col :xs="24">
                            <el-form-item class="u-text-right u-mt-15">
                                <el-button type="primary" id="btn-parametro" native-type="submit">SALVAR</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </el-form>
        
        </c-panel>
    </div>
</template>
<script>

export default {
    props: ['paramId'],
    data: () => ({
        editParametro: false,
        alert: false,
        dados: {
            id: '',
            status_pre_matricula: '',
            fase_matricula: '',
            periodo_letivo_base_nome: ''
        }

    }),
    mounted(){

        this.getParametros();
    },
    methods:{
        getParametros(){

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/parametro/get`, this.$store.getters.getHeaderAuth).then(response => {

                this.dados = JSON.parse(JSON.stringify(response.data));
 
            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        onSubmitParametro(){

            document.getElementById("btn-parametro").focus();

            this.$refs.dados.validate((valid) =>{ if(valid){
 
                window.eventBus.$emit('loading', true);                

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/parametro/updateSistemaMatricula`, { status_pre_matricula: this.dados.status_pre_matricula }, this.$store.getters.getHeaderAuth).then(response => {

                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                    this.getParametros();
                    
                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
        }
    }
}
</script>
